import { Component, Vue, Prop } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import Highcharts, { PointOptionsObject, SeriesColumnOptions } from 'highcharts';

@Component<BarChart>({})
export default class BarChart extends Vue {
  @Prop()
  protected data?: PointOptionsObject[];

  @Prop()
  protected series?: SeriesColumnOptions[];

  @Prop()
  protected categories?: string[];

  @Prop()
  protected colors?: string[];

  @Prop()
  protected name?: string;

  @Prop()
  protected stacking?: boolean;

  @Prop()
  protected tooltipPrefix?: string;

  protected chartData: PointOptionsObject[] | undefined = [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected chart: any;

  protected mounted(): void {
    this.chartData = cloneDeep(this.data);
    this.initialize();
  }

  protected initialize(): void {
    const chartContainer = (this.$refs.chart as HTMLElement);
    if (! chartContainer) {
      return;
    }

    if (this.colors) {
      Highcharts.setOptions({
        colors: this.colors,
      });
    }

    this.chart = Highcharts.chart({
      chart: {
        plotShadow: false,
        type: 'column',
        renderTo: chartContainer,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: this.categories,
      },
      yAxis: {
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: `<b>${this.tooltipPrefix ? this.tooltipPrefix : ''} {point.key}</b><br>`,
        pointFormat: '{series.name}: <b>{point.y}</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      plotOptions: { column: { stacking: this.stacking ? 'normal' : undefined } },
      series: this.stacking ? this.series
        : [{
          type: 'column',
          name: this.name,
          dataLabels: {
            enabled: true,
            shadow: false,
            style: {
              fontWeight: 'bold',
              textOutline: 'none',
            },
            formatter() { return `${this.y}`; },
          },
          data: this.chartData,
        }],
    });
  }
}
